// @flow
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { setMobilePhoneNumber } from 'store/reducers/appointment/actions';
import {
  setWaitState,
  setCustomerMobileNumber
} from 'store/reducers/selfCheckIn/actions';
import {
  gtmContactPreferenceMethod,
  gtmNoAdvisorOptions
} from 'store/reducers/gtm/actions';

// Component
import NoAdvisorAssistance from './NoAdvisorAssistance';

// Selectors
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import { getPersonInfo } from 'store/reducers/user/personInfo/selectors';
import { getContactInfo } from 'store/reducers/appointment/selectors';
import {
  getCustomerMobileNumber,
  getSelfCheckinWaitState
} from 'store/reducers/selfCheckIn/selectors';
import { showSCIProgressBar } from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = state => ({
  dealerCountryCode: getDealerCountryCode(state),
  personInfo: getPersonInfo(state),
  contactInfo: getContactInfo(state),
  customerMobileNumber: getCustomerMobileNumber(state),
  selfCheckinWaitState: getSelfCheckinWaitState(state),
  showSCIProgressBar: showSCIProgressBar(state)
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      goTo,
      setMobilePhoneNumber,
      setWaitState,
      setCustomerMobileNumber,
      gtmContactPreferenceMethod,
      gtmNoAdvisorOptions
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(NoAdvisorAssistance);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SpeakToAdvisorPage/NoAdvisorAssistance/NoAdvisorAssistanceContainer.js